import Vue from 'vue';
import constants from '@/js/services/constants';

Vue.prototype.$const = constants;
